import { Toaster } from "sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { BrandMarquee } from "@/components/site/BrandMarquee";
import { WhoFor } from "@/components/site/WhoFor";
import { Services } from "@/components/site/Services";
import { Inclusive } from "@/components/site/Inclusive";
import { Nutrition } from "@/components/site/Nutrition";
import { OnlineCoaching } from "@/components/site/OnlineCoaching";
import { Manifesto } from "@/components/site/Manifesto";
import { ServiceArea } from "@/components/site/ServiceArea";
import { FAQ } from "@/components/site/FAQ";
import { ContactForm } from "@/components/site/ContactForm";
import { Footer } from "@/components/site/Footer";
import { StickyBar } from "@/components/site/StickyBar";

export default function Landing() {
  return (
    <div className="bg-[#020617] min-h-screen">
      <Toaster position="top-center" theme="dark" richColors />
      <Nav />
      <main className="pb-20 md:pb-0">
        <Hero />
        <BrandMarquee />
        <WhoFor />
        <Services />
        <Inclusive />
        <Nutrition />
        <OnlineCoaching />
        <Manifesto />
        <ServiceArea />
        <FAQ />
        <ContactForm />
      </main>
      <Footer />
      <StickyBar />
    </div>
  );
}
